import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const UserManagementDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_userManagement_home"
  />
);

export default UserManagementDefaultWidget;
